import * as CoreFns from '../utilities/CoreFns';
import { Icon } from '@iconify/react';
import increaseAllowanceStaking from '../images/IncreaseAllowanceStaking.png' ;
import stakingToText from '../images/StakingToText.png';
import unstakeAll from '../images/UnstakeAll.png';
import numberOfAddressesStaked from '../images/NumberOfAddressesStaked.png';
import transformAndMap from '../images/TransformAndMap.png';

function App(props) {

  var width = props.width;
  var set = props.set;

  var info = [];

  if (set.t === 'tabElements'){
    var addWhereText = set.addWhereText;
    var addLoc = set.addLoc;
    var addInst = CoreFns.getElementInfo(addWhereText).t;
    if (addWhereText === 'PANEL'){
      if (addLoc === 0){
        addInst += ', which will be positioned in a responsive manner based on the screen width. This should be the default choice. If you would like to position the element in a fixed position on the panel, click on the Fixed button';
      }else{
        addInst += ', in a fixed position in the panel (use this to place e.g. background images). If you would like to position the element relative to other elements in the panel, click on the Responsive button';
      }
    }
    var secondAdditional;
    if (addWhereText !== 'Page'){
      secondAdditional = ' Click on the gray area around the dApp design screen to add a Navigation Bar or Footer.';
    }

    if (addWhereText === 'PANEL'){
      if (addLoc === 0){
      }else{
        secondAdditional += ' You can click on the show/hide relative items icon on the right hand bar if you want to see / not see relatively items when you are handling your absolutely positioned items.'
      }
    }

    info = [{t:'para', v:'Click on one of the options shown on the list to add it to the ' + addInst + '.'}, 
      {t:'break'},     
      {t:'para', v:'CUES uses the Bootstrap framework to create mobile-first dApps.'},
      {t:'break'},
      {t:'paraL', v:[{t:'bold', v:'Containers'}]},
      {t:'para', v:'Containers are the most basic layout element in Bootstrap. We have made it such that only containers can be directly added as the base to panels so that you can make full use of the Bootstrap grid system with its responsive breakpoints. We only allow rows to be added into containers.'},
      {t:'break'},
      {t:'paraL', v:[{t:'bold', v:'Rows'}]},
      {t:'para', v:'Rows are wrappers for elements. Each row should include a set of elements where the sum of their widths add up to 12 or fewer. The element widths do not have to add up to exactly 12. If their widths add up to more than 12, then those exceeding will wrap onto the next line.'},
      {t:'break'},
      {t:'paraL', v:[{t:'bold', v:'Elements'}]},
      {t:'para', v:'All content appears as Elements. Clicking on an element after you have added it will cause a row of options to appear on the top bar. You can use these options to style your element'},
      {t:'break'},
      {t:'para', v:secondAdditional}
    ];


  }else if (set.t === 'responsiveEditor'){
    info = [
          {t:'para', v:'This formula editor allows you to specify dynamic values. The editor shows different selections based on the type required.'}, 
          {t:'break'}, 
          {t:'para', v:'For example, if the type required is a Text, only formulas that yield a Text is shown. The same is true for example, for Integers.'}, 
          {t:'break'}, 
          {t:'para', v:'Therefore, to show an integer or a positive integer in a textbox, you will have to first select a function such as "Decimal to Text", or "Unsigned Integer to Text". These are found under the House Functions tab. Similarly, contract functions unsually take in unsigned integers.'}, 
          {t:'break'}, 
          {t:'paraL', v:[{t:'bold', v:'Examples'}]},
          {t:'break'}, 
          {t:'para', v:'1) Token amounts are represented as super-long unsigned integers. Typically, 1 coin is represented as 1000000000000000000. This tends not to be readable in a human-friendly format, and typically needs to be converted to a decimal. Hence, if you would like to show a token amount, such as the staked amount in a staking contract, or balance amount, select (as per the image below)'},
          {t:'list', v:[
            [{t:'para', v:'Decimal to Text (from the House functions tab)'},
              {t:'list', v:[
                [{t:'para', v:'Unsigned Integer to Decimal (from the House functions tab)'},
                  {t:'list', v:[
                    [{t:'para', v:'The relevant contract function (from the Contract functions tab)'}],
                    [{t:'para', v:'The number of decimal points of the coin (typically 18)'}],
                    [{t:'para', v:'The number of decimal points of that you will like to show (typically 2)'}]
                  ]}
                ]
              ]}
            ],
            [{t:'para', v:'Specify the number of decimal places that you will like to show (typically 2)'}]
          ]},
          {t:'image', v:stakingToText},
          {t:'break'}, 
          {t:'para', v:'2) If you would like to represent a value such as the number of users, select (as per the image below)'},
          {t:'list', v:[
            [{t:'para', v:'Unsigned Integer to Text (from the House functions tab)'},
              {t:'list', v:[
                [{t:'para', v:'The relevant contract function (from the Contract functions tab)'},
                ]
              ]}
            ]
          ]},
          {t:'image', v:numberOfAddressesStaked},
          {t:'break'}, 
          {t:'para', v:'3) This is an example to show that we can do much more complex things using a formula bar, in this case its about aggregating amount staked across multiple users. Note that in this case, you can simply call the totalStakedAmount function of the staking contract, rather than go through all this pain.'},
          {t:'image', v:transformAndMap}
      ];
  }else if (set.t === 'tabColors'){
    info = [{t:'para', v:'Palettes are sets of colors that go nicely together. We have some color palettes that you might want to consider using.'}, {t:'break'}, {t:'para', v:'Pick a palette here to make it easier for you to pick matching and contrasting colours when you are choosing colors for your dApp. Click on the color palettes to access them later in when editing the styles of the elements.'}];
  }else if (set.t === 'tabContracts'){
    info = [{t:'para', v:'Load or add your contracts here.'}, {t:'break'}, {t:'para', v:'Contracts can be called as actions (e.g. On Click or On Change), or as components when you specify a formula.'}];
  }else if (set.t === 'tabNavigator'){
    info = [{t:'para', v:'See the overall structure of your dApp.'}, {t:'break'}, {t:'para', v:'Click to edit the element, or drag and drop them to another part of your dApp.'}];
  }else if (set.t === 'tabOverallStyles'){
    info = [{t:'para', v:'Set the overall styles of your dApp here, such as the font, text color, and background color.'}, {t:'break'}, {t:'para', v:'By clicking on the hourglass icon, you can also add actions that execute once users start your dApp, e.g. pop up to inform users of discounts.'}];
  }else if (set.t === 'tabPages'){
     info = [{t:'para', v:'Add new pages and pop-ups here.'}, {t:'break'}, {t:'para', v:'If there are more than 1 pages in your dApp, set the starting page by clicking on the map route icon.'}, {t:'break'}, {t:'para', v:'Show Pop-Ups in your dApp by selecting the "Open a Pop Up Window" action via the On Click action icon in elements such as the Button.'}];
//
  }else if (set.t === 'tabUserDefinitions'){
     info = [{t:'para', v:'Add variables and specify their name type, and initial values.'},
      {t:'break'},
      {t:'para', v:'Basic Types'}, 
     {t:'list', v:[
      [{t:'paraL', v:[{t:'bold', v:'Blockchain Address'}, {t:'span', v:': Unique sequence of numbers and letters.'}]}],
      [{t:'paraL', v:[{t:'bold', v:'Boolean'}, {t:'span', v:': Only has two possible values: True or False.'}]}],
      [{t:'paraL', v:[{t:'bold', v:'Date Time'}, {t:'span', v:': Comprising of year, month, day and time. Date set here will be in local time.'}]}],
      [{t:'paraL', v:[{t:'bold', v:'Decimal'}, {t:'span', v:': Decimal includes both a whole and a fractional part (e.g. 3.14).'}]}],
      [{t:'paraL', v:[{t:'bold', v:'Integer'}, {t:'span', v:': Whole numbers that can either be positive or negative (e.g. -1 and 1).'}]}],
      [{t:'paraL', v:[{t:'bold', v:'List'}, {t:'span', v:': Sequence of multiple elements that is changeable.'}]}],
      [{t:'paraL', v:[{t:'bold', v:'Positive Integer / Unsigned Integer'}, {t:'span', v:': Whole numbers that can only be positive, including 0.'}]}],
      [{t:'paraL', v:[{t:'bold', v:'Text/String'}, {t:'span', v:': Sequence of characters (e.g. AB#120)'}]}]
     ]},
     {t:'para', v:'You may then change these variables through "On Click" or "On Change" actions of elements such as buttons / inputs. Alternatively, create new Struct types.'}];
  }else if (set.t === 'introPrevious'){
     info = [{t:'para', v:'Here, you can view the details of your dApps, whether unfinished or launched.'}, {t:'break'}, {t:'para', v:'You can also duplicate previous dApps and edit them to launch a different dApp, or delete unfinished dApps that you do not wish to continue.'}, {t:'break'}, {t:'para', v:'Click the edit button of a dApp to update the dApp, access the statistics or add more time to the website.'}];
  }else if (set.t === 'formulaOrDirect'){    
    if (set.v === 'Text String'){
     info = [{t:'para', v:'If you have a fixed text, you can specify it directly by keying it in, using the direct response mode.'}, {t:'break'}, {t:'para', v:'Otherwise, if you want your text to vary dynamically based on user actions or the state of the blockchain, use the formula mode instead. The formula screen will pop-up and you can follow the guide on that page.'}];
    }
  }else if (set.t === 'guidedIntro'){
   info = [{t:'para', v:'Choose from our available templates or start with a blank screen. Click on any template to preview the template before making your selection.'}, {t:'break'}, {t:'paraL', v:[{t:'link', v:'Watch Tutorial', link:'https://www.youtube.com/watch?v=jKJ6xszobVo&t=8s'}]}];
  }else if (set.t === 'actions'){
     info = [{t:'para', v:'Specify the actions that result from a user action.'},
      {t:'break'},
     {t:'paraL', v:[{t:'span', v:'Click '}, {t:'link', v:'[here]', link:'https://www.cues.sg/guide/dapp-builder-how-to-use-actions'}, {t:'span', v:' for explanations of each of the possible functions.'}]},
      {t:'break'},
     {t:'paraL', v:[{t:'bold', v:'Examples'}]},
      {t:'break'},
      {t:'para', v:'1) If you are trying to stake / exchange a token (not native currency e.g. ETH or BNB), you will need to call the increase allowance of the token contract first, and specify the spender as the token contract address, and the amount as the value that you would like to stake / exchange. See image below as illustration.'},
      {t:'image', v:increaseAllowanceStaking},
      {t:'para', v:'The incraseAllowance function may be missing in some contracts. In those cases, you can use the approval function of the token contract instead.'},
      {t:'break'},
      {t:'para', v:'* Note that this does not apply if you are trying to stake/exchange the native currency e.g. ETH or BNB. In those cases you do not need to increase allowance, but can directly call the stake/exchange function as the first step.'},
      {t:'break'},
      {t:'para', v:'* Please ensure that your staking / exchange contract owns sufficient amounts of the tokens that you want the users to exchange or stake. Otherwise the transaction will fail and you will be very irritated.'},
      {t:'break'},
      {t:'para', v:'2) If you would like your user to unstake all his/her current stake, fill up the actions as per the illustration below.'},
      {t:'image', v:unstakeAll}

     ];    
  }else if (set.t === 'colWidth'){
    info = [{t:'para', v:'All elements occupy a 1 or more column widths. A row comprises 12 columns.'}];
  }else if (set.t === 'rFormula'){
    info = [{t:'para', v:'If you would like this element to repeat itself multiple times, click dynamic.'}];
  }else if (set.t === 'fontFamily'){
    info = [{t:'para', v:'Choose font family here, if you want the element to have a different font family from the overall font family that you set under overall styles.'}];
  }else if (set.t === 'fontColor'){
    info = [{t:'para', v:'Choose font color here. You can specify the color of both the text itself, or the highlighting of the text'},
    {t:'break'},
    {t:'paraL', v:[
            {t:'span', v:'The "Colors" '},
            {t:'icon', v:'bi:palette'},
            {t:'span', v:' tab on the left-hand bar can be used to select palettes of colors that can go well together.'}
            ]}];
  }else if (set.t === 'color'){
    info = [{t:'para', v:'Choose the '+set.n+' here by clicking on the palette, or remove color (i.e. make it transparent) by clicking on the remove color link below.'}];
    if (set.gotForm){
      info.push({t:'break'});
      info.push({t:'para', v:'Click on the formula link (below the palette) to enable color that varies based on user input or the state of a blockchain.'})
    }

  }else if (set.t === 'topRow'){
    if (set.guideItem === 'DIV' || set.guideItem === 'SUMMARYDIV'){
      info = [{t:'paraL', v:[
            {t:'span', v:'Textboxes contain texts. To have rich, dynamic text that can change depending on user inputs or the state of the blockchain, select the "Rich dynamic text" '},
            {t:'icon', v:'carbon:text-footnote'},
            {t:'span', v:' option.'}
            ]}];
     
    }else if (set.guideItem === 'asset'){
      info = [{t:'paraL', v:[
                {t:'span', v:'This is a rich, dynamic text. To amend what this text shows, click the "Label" '}, 
                {t:'icon', v:'bx:text'},
                {t:'span', v:' icon.'}
      ]}];

    }else if (set.guideItem === 'navBar'){
      info = [{t:'paraL', v:[
                {t:'span', v:'This is a Navigation Bar, which is the top item of each page. You can add elements to the Navigation bar via the "Add Item" '}, 
                {t:'icon', v:'ion:shapes-outline'},
                {t:'span', v:' tab on the left hand column.'}
      ]}];

    }else if (set.guideItem === 'SPACE'){
      info = [{t:'paraL', v:[
                {t:'span', v:'This is a Space element that enables you to place gaps between elements. You can specify the width of the space via the "Style" '},
                {t:'icon', v:'clarity:design-line'},
                {t:'span', v:' icon.'}
              ]}];      
    }else if (set.guideItem === 'SUMMARY'){
      info = [{t:'paraL', v:[
                {t:'span', v:'This is a Summary, with a list of summary items, each which comprises a summary paragraph as well as an elaboration if the user clicks on it. You can add summary items to the Summary by clicking on the "Add Item" '},
                {t:'icon', v:'ion:shapes-outline'},
                {t:'span', v:' icon on the left-hand bar.'}
              ]}];      
    }else if (set.guideItem === 'TABLE'){
      info = [{t:'paraL', v:[
                {t:'span', v:'This is a Table, which comprises table rows. You can add items to the Table by clicking on the "Add Item" '},
                {t:'icon', v:'ion:shapes-outline'},
                {t:'span', v:' icon on the left-hand bar.'}
              ]}];      
    }else if (set.guideItem === 'TR'){
      info = [{t:'paraL', v:[
                {t:'span', v:'This is a Table Row, which comprises table cells. You can add items to the Table Rows by clicking on the "Add Item" '},
                {t:'icon', v:'ion:shapes-outline'},
                {t:'span', v:' icon on the left-hand bar.'}
              ]}];      
    }else if (set.guideItem === 'TD'){
      info = [{t:'paraL', v:[
                {t:'span', v:'This is a Table Cell, which holds elements. You can add items to the cell by clicking on the "Add Item" '},
                {t:'icon', v:'ion:shapes-outline'},
                {t:'span', v:' icon on the left-hand bar.'}
              ]}];      
    }else if (set.guideItem === 'TABS'){
      info = [{t:'paraL', v:[
                {t:'span', v:'This is a set of Tabs, which holds tab items that a user can view by clicking on the respective tab header. You can add items to the Tab by clicking on the "Add Item" '},
                {t:'icon', v:'ion:shapes-outline'},
                {t:'span', v:' icon on the left-hand bar.'}
              ]}];      
    }else if (set.guideItem === 'TABITEM'){
      info = [{t:'paraL', v:[
                {t:'span', v:'This is a Tab Item, which holds contents. You can add items to the Tab Item by clicking on the "Add Item" '},
                {t:'icon', v:'ion:shapes-outline'},
                {t:'span', v:' icon on the left-hand bar.'}
              ]}];      
    }else if (set.guideItem === 'CARD'){
      info = [{t:'paraL', v:[
                {t:'span', v:'This is a Card element, which holds contents. You can add items to the Card by clicking on the "Add Item" '},
                {t:'icon', v:'ion:shapes-outline'},
                {t:'span', v:' icon on the left-hand bar.'}
              ]}];      
    }else if (set.guideItem === 'LINECHART'){
      info = [{t:'paraL', v:[
                {t:'span', v:'This is a Line Chart. You can specify the data source by clicking the "Data" '},
                {t:'icon', v:'bi:clipboard-data'},
                {t:'span', v:' icon.'}
              ]}];      
    }else if (set.guideItem === 'ICON'){
      info = [{t:'paraL', v:[
                {t:'span', v:'This is an Icon element. You can specify actions on clicking the icon by clicking the "On Click" '},
                {t:'icon', v:'icon-park-outline:click'},
                {t:'span', v:' icon.'}
              ]}];      
    }else if (set.guideItem === 'BUTTON'){
      info = [{t:'paraL', v:[
                {t:'span', v:'This is a Button element. You can specify actions on clicking the button by clicking the "On Click" '},
                {t:'icon', v:'icon-park-outline:click'},
                {t:'span', v:' icon.'}
              ]}];      
    }else if (set.guideItem === 'TIMER'){
      info = [{t:'paraL', v:[
                {t:'span', v:'This is a Timer element, which allows you to specify the time that has passed from a reference time, or the time that is remaining before a reference time. You can specify the reference time by clicking the "Style" '},
                {t:'icon', v:'clarity:design-line'},
                {t:'span', v:' icon.'}
              ]}];      
    }else if (set.guideItem === 'VIDEO'){
      info = [{t:'paraL', v:[
                {t:'span', v:'This is a Video element. You can specify the Youtube Video ID, as well as other video characteristics, by clicking the "Style" '},
                {t:'icon', v:'clarity:design-line'},
                {t:'span', v:' icon.'}
              ]}];      
    }else if (set.guideItem === 'GALLERY'){
      info = [{t:'paraL', v:[
                {t:'span', v:'This is a Gallery element. You can specify the images shown by clicking the "Images" '},
                {t:'icon', v:'akar-icons:image'},
                {t:'span', v:' icon.'}
              ]}];      
    }else if (set.guideItem === 'IMG'){
      info = [{t:'paraL', v:[
                {t:'span', v:'This is an Image element. You can specify actions on clicking the image by clicking the "On Click" '},
                {t:'icon', v:'icon-park-outline:click'},
                {t:'span', v:' icon.'}
              ]}];      
    }else if (set.guideItem === 'INPUT'){
      info = [{t:'paraL', v:[
                {t:'span', v:'This is an Input element, which enables user inputs. The type of user input allowed (e.g. text, integers, decimals, or drop-down select menus, etc) can be specified in the "Style" '},
                {t:'icon', v:'clarity:design-line'},
                {t:'span', v:' icon. You can specify actions when the input is changed by clicking the "On Change" '},
                {t:'icon', v:'material-symbols:change-circle-outline-rounded'},
                {t:'span', v:' icon.'}
              ]}];      
    }else if (set.guideItem === 'HFLEX'){
      info = [{t:'para', v:'This is a Horizontal Row, which contains various elements, such as buttons, text boxes, and input boxes.'}, 
        {t:'break'}, 
        {t:'paraL', v:[
          {t:'span', v:'Elements can be added via the "Add Item" '}, 
          {t:'icon', v:'ion:shapes-outline'},
          {t:'span', v:' tab on the left hand column.'}]}, 
        {t:'break'}, 
        {t:'para', v:'Each row should include a set of elements where the sum of their widths add up to 12 or fewer. The  widths do not have to add up to exactly 12. If their widths add up to more than 12, then those exceeding will wrap onto the next line.'}, 
        {t:'break'}, 
        {t:'paraL', v:[
            {t:'span', v:'However, there are cases where this might not apply, especially for shorter rows. In a 12 column layout, one column will be 8.333% (100%/12) of the total width. The minimum width of a 12 column layout is then 360px due to default left and right padding of 15px per column. Remove this padding between your columns by choosing None for Spaces between Columns under the "Style" '},
            {t:'icon', v:'clarity:design-line'},
            {t:'span', v:' icon.'}
          ]}
        ];
    }else if (set.guideItem === 'CONTAINER'){
      info = [{t:'para', v:'This is a Container. Containers are the most basic layout element in Bootstrap. Only containers can be directly added as baseline responsive elements of Panels so that you can make full use of the Bootstrap grid system with its responsive breakpoints.'}, 
        {t:'break'}, 
        {t:'paraL', v:[
          {t:'span', v:'Containers comprise a number of Rows. Rows can be added via the "Add Item" '}, 
          {t:'icon', v:'ion:shapes-outline'},
          {t:'span', v:' tab on the left hand column.'}]}, 
        {t:'break'}, 
        {t:'paraL', v:[
          {t:'span', v:'Under "Style" '}, 
          {t:'icon', v:'clarity:design-line'},
          {t:'span', v:' , you will see there is an option for Styled Container. Choosing Yes would set a max-width at each breakpoint. The breakpoints are the device screen sizes on the main tab. Choosing No would set the width as 100% at all breakpoints and the default styles for container will not be used.'}]}
        ];
    }else if (set.guideItem === 'screen'){
      info = [{t:'para', v:'This is a panel. Panels comprise responsive elements following the Bootstrap system, as well as fixed positioned elements that are placed in the same position relative to the corners of the panel.'},
        {t:'break'}, 
        {t:'paraL', v:[
          {t:'span', v:'These elements can be added via the "Add Item" '}, 
          {t:'icon', v:'ion:shapes-outline'},
          {t:'span', v:' tab on the left hand column.'}]},
        {t:'break'}, 
        {t:'paraL', v:[
          {t:'span', v:'The responsive elements can be shown/hidden via the "Show/Hide Responsive Elements" '}, 
          {t:'icon', v:'ic:outline-image'},
          {t:'span', v:' '}, 
          {t:'icon', v:'ic:outline-hide-image'},
          {t:'span', v:' icons.'}]}

      ];
    }else if (set.guideItem === 'footer'){
      info = [{t:'para', v:'This is a footer. The footer is a panel that can be repeated across pages. It comprises responsive elements following the Bootstrap system, as well as fixed positioned elements that are placed in the same position relative to the corners of the footer.'},
        {t:'break'}, 
        {t:'paraL', v:[
          {t:'span', v:'These elements can be added via the "Add Item" '}, 
          {t:'icon', v:'ion:shapes-outline'},
          {t:'span', v:' tab on the left hand column.'}]}

      ];
    }else if (set.guideItem === 'page' || set.guideItem === 'popUp'){

      var cover = 'This is a page. A page is the baseline unit of each dApp, and comprises an optional Navigation Bar, panels, and an optional Footer.';
      if (set.guideItem === 'popUp'){
        cover = 'This is a pop-up. A pop-up comprises an optional Navigation Bar, panels, and an optional Footer.';
      }
      info = [{t:'para', v: cover},
        {t:'break'},
        {t:'para', v:'Panels can be added by the "+ Panel" at the bottom of the display screen.'},
        {t:'break'}, 
        {t:'paraL', v:[
          {t:'span', v:'The Navigation Bar and Footer can be added via the "Add Item" '}, 
          {t:'icon', v:'ion:shapes-outline'},
          {t:'span', v:' tab on the left hand column.'}]},
        {t:'break'},
        {t:'para', v:'Individual panels, or elements of each panel, can be amended by clicking on it.'} 
      ];
    }else{
      console.log(set);
      info = [{t:'para', v:'We are gradually filling up this guide'}];
    }
    if (set.gotUp){
      info.push({t:'break'});
      info.push({t:'paraL', v:[
          {t:'span', v:'To access the parent '+set.gotUp+', click the "Amend Parent" '},
          {t:'icon', v:'carbon:folder-parent'},
          {t:'span', v:' option.'}

          ]});      
    }

      info.push({t:'break'});
      info.push({t:'paraL', v:[
          {t:'span', v:'Please contact us via Telegram at @cuessg if you have further queries. You may also wish to join our community check by clicking '}, {t:'link', v:'here', link:'https://t.me/+yK9fP_1z27Q2NzVl'}, {t:'span', v:'. Thank you!'}]});

  }else{
    console.log(set);
  }

  info.push({t:'break'});
  info.push({t:'paraL', v:[
      {t:'span', v:'Click '}, {t:'link', v:'here', link:'https://www.youtube.com/watch?v=jKJ6xszobVo&list=PLAc4K9R1vVPQxZIGDam6X3MLMlbr2sOCT'}, {t:'span', v:' to watch our tutorial video series.'}]});
  info.push({t:'break'});
  info.push({t:'paraL', v:[
      {t:'span', v:'Click '}, {t:'link', v:'here', link:'https://www.youtube.com/watch?v=9Ji7yB0t3So'}, {t:'span', v:' to see how to display crypto balances.'}]});

  

  function doAList(infoIn){
    return infoIn.map((anInfo, index)=>{
      if (anInfo.t === 'para'){
        return <p className='lead mb-0'>{anInfo.v}</p>
      }else if (anInfo.t === 'paraL'){
        return <p className='lead mb-0'>{doAList(anInfo.v)}</p>
      }else if (anInfo.t === 'bold'){
        return <b>{anInfo.v}</b>
      }else if (anInfo.t === 'span'){
        return <span>{anInfo.v}</span>
      }else if (anInfo.t === 'image'){
        return <center><img alt='described' src={anInfo.v} style={{padding:'5px', maxWidth:'80%'}} /></center>
      }else if (anInfo.t === 'link'){

        function clickExplanations(e){
          window.open(anInfo.link);
        }
        return <span style={{cursor:'pointer', textDecoration:'underline'}} onClick={clickExplanations}>{anInfo.v}</span>
      }else if (anInfo.t === 'break'){
        return <br/>
      }else if (anInfo.t === 'icon'){
        return <Icon height='25px' icon={anInfo.v} />
      }else if (anInfo.t === 'list'){
        var items = anInfo.v.map((aP, index2)=>{
          return <li key={index2}>{doAList(aP)}</li>
//
        })
        return <ul>{items}</ul>
//
      }
      return null;
    })

  }

  var infoOut = doAList(info);

//  
  return <div style={{width:width*0.7, textAlign:'left'}}>{infoOut}
    </div>

}

export default App;
